export const stringifyAddress = ({
  address,
  city,
  state,
  zipcode,
}) => (address && city && state && zipcode && `${address}, ${city}, ${state} ${zipcode}`) || '';
